import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { TID } from "@/constants/testIds";
import Logo from "@/components/Logo";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const dashPath =
    user && user.role === "admin" ? "/dashboard/agency"
    : user && user.role === "employer" ? "/dashboard/employer"
    : user && user.role === "candidate" ? "/dashboard/candidate"
    : "/login";

  return (
    <header className="nav-glass sticky top-0 z-50">
      <div className="container-ax flex items-center justify-between py-4">
        <Link to="/" data-testid={TID.navBrand} className="flex items-center gap-2.5 group">
          <Logo size={36} variant="dark" />
          <div className="leading-tight">
            <div className="font-display font-bold text-navy text-lg">Recruvo</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-slate-500 -mt-0.5">Group</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-700">
          <Link to="/jobs" className="hover:text-navy transition-colors">Browse Jobs</Link>
          <Link to="/about" className="hover:text-navy transition-colors">About</Link>
          <a href="/#industries" className="hover:text-navy transition-colors">Industries</a>
          <a href="/#faq" className="hover:text-navy transition-colors">FAQ</a>
          <a href="/#contact" className="hover:text-navy transition-colors">Contact</a>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashPath} className="btn-navy text-sm py-2 px-4">Dashboard <ChevronRight className="w-4 h-4" /></Link>
              <button data-testid={TID.navLogout} onClick={async () => { await logout(); navigate("/"); }}
                className="text-sm text-slate-600 hover:text-navy transition-colors">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid={TID.navLogin} className="text-sm font-medium text-navy hover:opacity-80">Sign in</Link>
              <Link to="/register" data-testid={TID.navRegister} className="btn-gold text-sm py-2 px-4">Get Started <ChevronRight className="w-4 h-4" /></Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid={TID.mobileMenuToggle}>
          {open ? <X className="w-6 h-6 text-navy" /> : <Menu className="w-6 h-6 text-navy" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="container-ax flex flex-col gap-3 py-4 text-slate-700">
            <Link to="/jobs" onClick={() => setOpen(false)}>Browse Jobs</Link>
            <Link to="/about" onClick={() => setOpen(false)}>About</Link>
            <a href="/#industries" onClick={() => setOpen(false)}>Industries</a>
            <a href="/#faq" onClick={() => setOpen(false)}>FAQ</a>
            <a href="/#contact" onClick={() => setOpen(false)}>Contact</a>
            <div className="h-px bg-slate-100 my-2" />
            {user ? (
              <>
                <Link to={dashPath} className="btn-navy text-sm w-fit" onClick={() => setOpen(false)}>Dashboard</Link>
                <button onClick={async () => { await logout(); setOpen(false); navigate("/"); }} className="text-slate-500 text-left">Sign out</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-navy font-medium">Sign in</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="btn-gold text-sm w-fit">Get Started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
